import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MsalModule } from '@azure/msal-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutoCompleteModule, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { AzureOauthResponseComponent } from './modules/azure-oauth-response/azure-oauth-response.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { EditAzureAccountComponent } from './modules/edit-azure-account/edit-azure-account.component';
import { EditEndpointComponent } from './modules/edit-endpoint/edit-endpoint.component';
import { EditNamespaceComponent } from './modules/edit-namespace/edit-namespace.component';
import { LoginComponent } from './modules/login/login.component';
import { ManageAzureAccountsComponent } from './modules/manage-azure-accounts/manage-azure-accounts.component';
import { ManageEndpointsComponent } from './modules/manage-endpoints/manage-endpoints.component';
import { ManageNamespacesComponent } from './modules/manage-namespaces/manage-namespaces.component';
import { ConfirmationDialogComponent } from './shared/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './shared/components/confirmation-dialog/confirmation-dialog.service';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { PoweredByComponent } from './shared/components/powered-by/powered-by.component';
import { TwoFactorsCodeComponent } from './shared/components/two-factors-code/two-factors-code.component';
import { AZURE_CLIENT_ID, AZURE_TENANT_ID, isIE, LOADER_CONFIG } from './shared/constants';

export function initializeApp(appConfig: AppConfigService) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    NavbarComponent,
    PoweredByComponent,
    ManageAzureAccountsComponent,
    ManageNamespacesComponent,
    ManageEndpointsComponent,
    EditEndpointComponent,
    EditAzureAccountComponent,
    EditNamespaceComponent,
    ConfirmationDialogComponent,
    TwoFactorsCodeComponent,
    AzureOauthResponseComponent

  ],
  imports: [
    BrowserAnimationsModule,
    DropDownListModule,
    AutoCompleteModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxUiLoaderModule,
    NgxUiLoaderModule.forRoot(LOADER_CONFIG),
    NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
    NgxUiLoaderRouterModule.forRoot({ showForeground: true }),
    MsalModule.forRoot({
      auth: {
        clientId: AZURE_CLIENT_ID, // This is your client ID
        authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`, // This is your tenant ID
        redirectUri: `${environment.AZURE_REDIRECT_URL}/azureoauthresponse`// This is your redirect URI
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      },
    })
  ],
  providers: [
    NavbarComponent,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ConfirmationDialogService,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService], multi: true
    }
    // { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent]
})
export class AppModule { }
